import { IAuthorizationPolicyDocument } from "@/models/policy";
import { ModelValidation } from "@/models/modelvalidation";

export interface IUser {
    uuid?: string | null;
    role?: string | null;
    displayRole?: string | null;
    identityProvider?: string | null;
    emailAddress?: string | null;
    allServiceProviders: boolean | false;
    authorizationPolicyUuid?: string | null;
    policySetup?: IAuthorizationPolicyDocument;
    hashedIdentifier?: string | null;
}

export class User extends ModelValidation {
    public uuid!: string | null;
    public role!: string | null;
    public displayRole!: string | null;
    public identityProvider!: string | null;
    public emailAddress!: string | null;
    public allServiceProviders!: boolean | false;
    public authorizationPolicyUuid!: string | null;
    public policySetup!: IAuthorizationPolicyDocument;
    public hashedIdentifier!: string | null;

    constructor(user: IUser | any) {
        super();

        if (!user) {
            throw new Error("Cannot construct User from falsey IUser");
        }

        this.uuid = user.uuid || null;
        this.role = user.role || null;
        this.displayRole = user.displayRole || null;
        this.identityProvider = user.identityProvider || null;
        this.emailAddress = user.emailAddress || null;
        this.allServiceProviders = user.allServiceProviders || false;
        this.authorizationPolicyUuid = user.authorizationPolicyUuid || null;
        this.policySetup = user.policySetup || null;
        this.hashedIdentifier = user.hashedIdentifier || null;
    }

    public static empty(): User {
        return new User({});
    }

    public toNewUserDto(): IUser | any {
        return {
             role: this.role,
             displayRole: this.displayRole,
             identityProvider: "cognito",
             emailAddress: this.emailAddress,
             policySetup: this.policySetup
        };
    }

    public toUpdateUserDto(): IUser | any {
        // these wind up being the same implementation but are semantically different
        const result = this.toNewUserDto();
        result.uuid = this.uuid;
        result.authorizationPolicyUuid = this.authorizationPolicyUuid;
        return result;
    }
}
